import { render, staticRenderFns } from "./BottomMenuAuth.vue?vue&type=template&id=30c69726&scoped=true&"
import script from "./BottomMenuAuth.vue?vue&type=script&lang=js&"
export * from "./BottomMenuAuth.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenuAuth.vue?vue&type=style&index=0&id=30c69726&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c69726",
  null
  
)

export default component.exports